import React, { useState, useContext } from "react";
import styled from "styled-components";
import cl from "classnames";
import { Link } from "react-router-dom";

//
import AuthContext from "../../context/auth/AuthContext";
import CourseContext from "../../context/course/CourseContext";
import logo from "../../assets/images/logo.webp";
import rus from "../../assets/images/russia.svg";
import en from "../../assets/images/en.svg";

export default function Navbar({ fluid = false }) {
  // context
  const {
    state: { isAuth, user },
  } = useContext(AuthContext);
  const {
    state: { courses },
  } = useContext(CourseContext);

  // state
  const [courseMenu, setCourseMenu] = useState(false);
  const [langMenu, setLangMenu] = useState(false);
  const [headerMenu, setHeaderMenu] = useState(false);

  function changeCourseMenu(v) {
    setCourseMenu(v);
  }

  function changeLangMenu(v) {
    setLangMenu(v);
  }

  function changeHeaderMenu(v) {
    setHeaderMenu(v);
  }

  return (
    <StyledNavbar
      className={cl("header", {
        "header-lesson": fluid,
      })}
    >
      <div
        className={cl({
          container: !fluid,
          "container-fluid": fluid,
        })}
      >
        <div className="header_row">
          <Link to="/" className="header_logo">
            <img width="30" src={logo} alt="logo" />
          </Link>
          <Link
            to={"#"}
            className="js_showNav"
            onClick={() => changeHeaderMenu(!headerMenu)}
          >
            <span className="js_showNav_icon"></span>
          </Link>

          <div
            className={cl("header_nav", {
              active: headerMenu,
            })}
          >
            <ul className="header_nav_list">
              <li className="header_nav_item dropdown">
                <Link
                  to={"#"}
                  className="header_nav_link"
                  onClick={() => changeCourseMenu(!courseMenu)}
                >
                  Выберите курс
                </Link>
                <ul
                  className={cl("dropdown_menu", {
                    active: courseMenu,
                  })}
                >
                  {courses.map((i) => (
                    <li key={i.id}>
                      <Link
                        to="/html"
                        className="dropdown_menu_item"
                        onClick={() => changeCourseMenu(false)}
                      >
                        <span className="devicon-php-plain colored"></span>
                        <span>{i.content}</span>
                      </Link>
                    </li>
                  ))}
                  {/* <li>
                    <Link
                      to="/course"
                      className="dropdown_menu_item"
                      onClick={() => changeCourseMenu(false)}
                    >
                      <span className="devicon-php-plain colored"></span>
                      <span>PHP</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/course"
                      className="dropdown_menu_item"
                      onClick={() => changeCourseMenu(false)}
                    >
                      <span className="devicon-javascript-plain colored"></span>
                      <span>Javascript</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/course"
                      className="dropdown_menu_item"
                      onClick={() => changeCourseMenu(false)}
                    >
                      <span className="devicon-python-plain colored"></span>
                      <span>Python</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/course"
                      className="dropdown_menu_item"
                      onClick={() => changeCourseMenu(false)}
                    >
                      <span className="devicon-java-plain colored"></span>
                      <span>Java</span>
                    </Link>
                  </li> */}
                </ul>
              </li>
              <li className="header_nav_item">
                <Link to="#" className="header_nav_link">
                  История успеха
                </Link>
              </li>
              {isAuth ? (
                <>
                  <li className="header_nav_item">
                    <Link to="#" className="header_nav_link">
                      {user?.email}
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="header_nav_item">
                    <Link to="/auth/login" className="header_nav_link">
                      Вход
                    </Link>
                  </li>
                  <li className="header_nav_item">
                    <Link
                      to="/auth/register"
                      className="header_nav_link header_nav_reg"
                    >
                      Регистрация
                    </Link>
                  </li>
                </>
              )}

              <li className="header_nav_item dropdown">
                <Link
                  to="#"
                  className="header_nav_link"
                  onClick={() => changeLangMenu(!langMenu)}
                >
                  <span className="header_nav_country">
                    <img width="25" src={rus} alt="rus" />
                  </span>
                </Link>
                <ul
                  className={cl("dropdown_menu right-0", {
                    active: langMenu,
                  })}
                  style={{ right: "0" }}
                >
                  <li>
                    <Link
                      to="#"
                      className="dropdown_menu_item"
                      onClick={() => changeLangMenu(false)}
                    >
                      <span>
                        <img src={en} alt="en" width="25" />
                      </span>
                      <span>Английский</span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </StyledNavbar>
  );
}

const StyledNavbar = styled.nav`
  &.header {
    margin-bottom: 72px;

    &.header-lesson {
      margin-bottom: 0;

      .dropdown_menu {
        left: auto;
        right: 0;
      }

      .header_row {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
      }
    }
  }

  .header_row,
  .header_nav_list {
    display: flex;
    align-items: center;
  }
  .header_nav_list {
    margin-bottom: 0;
    padding-left: 0;
  }
  .dropdown_menu {
    display: none;
  }
  .dropdown_menu.active {
    display: block;
  }
  .dropdown_menu {
    position: absolute;
    z-index: 50;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
  }
  .dropdown_menu_item {
    display: flex;
    align-items: center;
    padding: 8px 16px;
  }

  .dropdown_menu_item span:last-of-type {
    white-space: nowrap;
  }

  .dropdown_menu_item:hover {
    background-color: #e9ecef;
  }
  .dropdown_menu_item > span:first-child {
    font-size: 1.25rem;
    margin-right: 8px;
    display: flex;
  }
  .header-lesson .dropdown_menu {
    left: auto;
    right: 0;
  }
  .header_logo {
    margin-right: 1.5rem;
  }
  .header_row {
    padding: 16px 0;
  }
  .header_nav_item:first-child {
    margin-right: 1.5rem;
  }
  .header_nav_link {
    padding: 0.5rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: rgba(33, 37, 41, 1) !important;
  }
  .header_nav_item:nth-child(3) {
    margin-left: auto;
    display: flex;
  }
  .header_nav {
    flex-grow: 1;
  }
  .header_row {
    border-bottom: 1px solid #dee2e6;
  }
  .dropdown > .header_nav_link:after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
  .header_nav_country {
    margin-right: 8px;
  }
  .header_nav_country img {
    vertical-align: middle;
  }
  .header_nav_reg {
    margin-right: 16px;
  }
  .header.header-lesson {
    margin-bottom: 0;
  }
  .header-lesson .header_row {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  @media (max-width: 576px) {
    .header_nav {
      flex-basis: 100%;
      align-items: center;
    }
    .header_row {
      flex-wrap: wrap;
    }
    .header_nav_list {
      flex-direction: column;
      align-items: flex-start;
    }
    .header_nav .header_nav_item {
      margin: 0;
    }

    .header_nav {
      display: none;
    }
    .header_nav.active {
      display: block;
    }
    .dropdown_menu {
      position: static;
      width: 100%;
    }
    .header_nav_item {
      width: 100%;
    }

    .js_showNav {
      display: block;
      margin-left: auto;
    }
  }
`;
